import { Avatar, Card, Icon, Tag, Typography } from "@ann/web-components";
import { ItemContainerChatHistory, ItemChatSend, ItemChatReceive, SummaryCardContainer, SummaryCardHeader, SummaryHeaderLeftContainer, HistoryContainer, MainContainer, DateDivider, DateLabel } from "./itemChat.styled";

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();

    if (date.toDateString() === today.toDateString()) {
        return "Today";
    }

    return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
};

const groupMessagesByDate = (messages) => {
    const grouped = [];
    let currentDate = null;

    messages.forEach((message) => {
        const messageDate = message.date;

        if (messageDate !== currentDate) {
            currentDate = messageDate;
            grouped.push({
                type: 'date-divider',
                date: messageDate,
                id: `divider-${messageDate}`
            });
        }

        grouped.push(message);
    });

    return grouped;
};

const DateDividerComponent = ({ date }) => {
    return (
        <DateDivider>
            <DateLabel>
                {formatDate(date)}
            </DateLabel>
        </DateDivider>
    );
};

const ItemChatSendComponent = ({ item }) => {

    return (
        <ItemContainerChatHistory>
            <Avatar
                size="lg"
                src="https://i.pravatar.cc/40"
            />

            <ItemChatSend>
                <Typography category="body" weight="regular" size="medium" color="body">
                    {item.body}
                </Typography>
            </ItemChatSend>

        </ItemContainerChatHistory>


    );
}

const ItemChatReceiveComponent = ({ item }) => {
    return (
        <ItemContainerChatHistory>

            <ItemChatReceive>
                <Typography category="body" weight="regular" size="medium" color="body">
                    {item.body}
                </Typography>
            </ItemChatReceive>

            <Avatar
                size="lg"
                src="https://i.pravatar.cc/40"
            />
        </ItemContainerChatHistory>


    );
}

const SummaryCard = () => {
    return (
        <Card size="small">
            <SummaryCardContainer>
                <SummaryCardHeader>
                    <SummaryHeaderLeftContainer>
                        <Icon name="aiChat" size="medium" />
                        <Typography category="subtitle" weight="bold" size="medium">Summary</Typography>
                    </SummaryHeaderLeftContainer>
                    <Icon name="close" size="medium" />
                </SummaryCardHeader>
            </SummaryCardContainer>
            <Typography category="body" weight="regular" size="medium">Reminder sent about oil change. Customer requests to schedule appointment for the following week and confirms proposed date.</Typography>
        </Card>
    )
}

const ChatHistory = ({ chatHistory }) => {
    const groupedMessages = groupMessagesByDate(chatHistory);

    return (
        <MainContainer>
            <HistoryContainer>
                {
                    groupedMessages.map((item) => {
                        if (item.type === 'date-divider') {
                            return <DateDividerComponent key={item.id} date={item.date} />;
                        }

                        return item.type === "send" ? (
                            <ItemChatSendComponent key={item.id} item={item} />
                        ) : (
                            <ItemChatReceiveComponent key={item.id} item={item} />
                        );
                    })
                }
            </HistoryContainer>
            <SummaryCard />
        </MainContainer>
    )
}


export default ChatHistory;